module.exports = __webpack_public_path__ + "es.e6a28e06.svg";